export const INTEGER_PATTERN = /^-?\d*$/;
export const PHONE_NUMMER_PATTERN = /^[0123456789.)(-\s+]+$/;
export const EMAIL_PATTERN = /^([^@\s]+@[^@\s]+\.[^@\s]+)$/;
export const EMAIL_NO_SPECIAL_CHARS_PATTERN = /^[a-zA-Z0-9.@_-]*$/;